module.exports = __webpack_public_path__ + "c76f8dce6ca6dcdd82f0d93cbfca86e9.svg";